import { render, staticRenderFns } from "./add-ethnicity.vue?vue&type=template&id=58315515&scoped=true"
import script from "./add-ethnicity.vue?vue&type=script&lang=js"
export * from "./add-ethnicity.vue?vue&type=script&lang=js"
import style0 from "./add-ethnicity.vue?vue&type=style&index=0&id=58315515&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58315515",
  null
  
)

export default component.exports